export default __webpack_public_path__ + "resources/icons/d431-3666.png";